import AbstractMark from './AbstractMark';
import {TextSelection} from "prosemirror-state";
import {getMarkRange} from "../helper/getMarkRange";

export default class RelativeTime extends AbstractMark {
    get name() {
        return 'relative_time';
    }

    get schema() {
        return {
            attrs: {
                datetime: {default: null},
                format: {default: null},
                hour: {default: null},
                minute: {default: null},
                second: {default: null},
            },
            parseDOM: [
                {
                    tag: 'relative-time,span.relative-time', getAttrs: dom => ({
                        datetime: dom.getAttribute('datetime'),
                        format: dom.getAttribute('format'),
                        hour: dom.getAttribute('hour'),
                        minute: dom.getAttribute('minute'),
                        second: dom.getAttribute('second'),
                    }),
                }],
            toDOM: mark => {
                const parsed = Date.parse(mark.attrs.datetime)
                if (Number.isNaN(parsed)) {
                    return [
                        'span', {
                            class: 'relative-time'
                        }, 0
                    ];
                } else {
                    return [
                        'relative-time', {
                            datetime: mark.attrs.datetime,
                            format: mark.attrs.format,
                            hour: mark.attrs.hour,
                            minute: mark.attrs.minute,
                            second: mark.attrs.second,
                        }, 0
                    ];
                }
            },
        };
    }

    get toMarkdown() {
        return {
            open: function open(_state, _mark) {
                return `<relative-time datetime="${_mark.attrs.datetime || ''}"${_mark.attrs.format ? ` format="${_mark.attrs.format}"` : ''}${_mark.attrs.hour ? ` hour="${_mark.attrs.hour}"` : ''}${_mark.attrs.minute ? ` minute="${_mark.attrs.minute}"` : ''}${_mark.attrs.second ? ` second="${_mark.attrs.second}"` : ''}>`;
            },
            close: '</relative-time>',
            mixable: true,
            expelEnclosingWhitespace: true,
        };
    }

    get parseMarkdown() {
        return {
            mark: 'relative_time', getAttrs: token => ({
                datetime: token.attrGet('datetime'),
                format: token.attrGet('format'),
                hour: token.attrGet('hour'),
                minute: token.attrGet('minute'),
                second: token.attrGet('second'),
            }),
        };
    }

    keys({type}) {
        return {
            ArrowLeft: (state, dispatch) => {
                const { empty, $cursor } = state.selection;
                if (!empty || !$cursor) {
                    return false;
                }
                const $pos = state.tr.doc.resolve($cursor.pos - 2)
                const range = getMarkRange($pos, state.schema.marks.relative_time);
                if (!range) {
                    return false;
                }
                dispatch(state.tr.setSelection(
                    TextSelection.create(state.doc, range.from, range.to)).
                scrollIntoView());
                return true;
            },
            ArrowRight: (state, dispatch) => {
                const { empty, $cursor } = state.selection;
                if (!empty || !$cursor) {
                    return false;
                }
                const $pos = state.tr.doc.resolve($cursor.pos + 1)
                const range = getMarkRange($pos, state.schema.marks.relative_time);
                if (!range) {
                    return false;
                }
                dispatch(state.tr.setSelection(
                    TextSelection.create(state.doc, range.from, range.to)).
                scrollIntoView());
                return true;
            }
        };
    }
}